"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.BuildLang = exports.setI18nLang = exports.getI18nLang = exports.createKeyset = void 0;
exports.createI18n = createI18n;
exports.createI18nRaw = createI18nRaw;
const react_1 = require("react");
const i18n_1 = __importStar(require("@yandex-int/i18n"));
var createKeyset_1 = require("./lib/keysets/createKeyset");
Object.defineProperty(exports, "createKeyset", { enumerable: true, get: function () { return createKeyset_1.createKeyset; } });
var i18n_2 = require("@yandex-int/i18n");
Object.defineProperty(exports, "getI18nLang", { enumerable: true, get: function () { return i18n_2.getI18nLang; } });
Object.defineProperty(exports, "setI18nLang", { enumerable: true, get: function () { return i18n_2.setI18nLang; } });
var langs_1 = require("./lib/langs");
Object.defineProperty(exports, "BuildLang", { enumerable: true, get: function () { return langs_1.BuildLang; } });
function createI18n(keyset) {
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions -- DIRECT-239681
    return (0, i18n_1.default)(keyset);
}
function createI18nRaw(keyset) {
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions -- DIRECT-239681
    const i18nRawInt = (0, i18n_1.i18nRaw)(keyset);
    const i18nRaw = function i18nRaw(key, options) {
        return i18nRawInt(key, options).map((node, index) => {
            if (typeof node !== 'object') {
                return node;
            }
            return (0, react_1.createElement)(react_1.Fragment, { key: index }, node);
        });
    };
    return i18nRaw;
}
